<template>
  <div class="projectPage">
      <div class="projectHeader">
          <div class="projectTitle">
              <div class="leftHeader">
                  <div id="projectDetailBtn" class="simpleBtn">
                      <i class="bi bi-three-dots-vertical"></i>
                  </div>
                  <div class="projectName">
                      <i class="bi bi-app"></i>
                      <span>{{projectInfo.Name}}</span>
                  </div>
              </div>
              <div class="rightHeader">
                  <button class="grayBtn" @click="showAlert()">
                      <i class="bi bi-person-add"></i>
                      <span>초대하기</span>
                  </button>
              </div>
          </div>
          <div class="projectMenu">
            <div id="feed" class="projectMenuItem" @click="navigateProjectMenu('feed')">피드</div>
            <div id="task" class="projectMenuItem active" @click="navigateProjectMenu('task')">업무</div>
            <div id="calendar" class="projectMenuItem" @click="navigateProjectMenu('calendar')">캘린더</div>
          </div>
      </div>
      <div class="projectListPageContainer">
          <div class="projectListPage">
            <div class="projectListHeader">
              <!-- 필터검색 : .open <-> .close -->
              <div :class="['filterPanelBox', isFilterOpen ? 'open' : 'close']"> 
                <div class="filterPanelContainer">
                  <div class="filterPanelHeader">
                    <span>필터</span>
                  </div>
                  <div class="filterPanelBody">
                    <!-- .filterPanelItemBox 클릭시 .active on/off -->
                    <div :class="['filterPanelItemBox projectFilter', isTaskCatgoryOpen ? 'active' : '']"> 
                      <div class="filterPanelItemTitle" @click="toggleTaskCategoryFilter">
                        <span>업무 구분</span>
                        <i class="bi bi-chevron-up"></i>
                      </div>
                      <div class="filterPanelItemList">
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="projectFilter" id="radioOption1">
                          <label for="radioOption1">전체 업무</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="projectFilter" id="radioOption2">
                          <label for="radioOption2">내가 담당한 업무</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="projectFilter" id="radioOption3">
                          <label for="radioOption3">내가 요청한 업무</label>
                        </div>
                      </div>
                    </div>
                    <div :class="['filterPanelItemBox statusFilter', isStatusCatgoryOpen ? 'active' : '']"> 
                      <div class="filterPanelItemTitle" @click="toggleStatusCategoryFilter">
                        <span>상태</span>
                        <i class="bi bi-chevron-up"></i>
                      </div>
                      <div class="filterPanelItemList">
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="statusFilter" id="checkOption1" checked>
                          <label for="checkOption1"><span class="colorBall request"></span>요청</label>
                        </div>
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="statusFilter" id="checkOption2" checked>
                          <label for="checkOption2"><span class="colorBall inProgress"></span>진행</label>
                        </div>
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="statusFilter" id="checkOption3" checked>
                          <label for="checkOption3"><span class="colorBall feedback"></span>피드백</label>
                        </div>
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="statusFilter" id="checkOption4" checked>
                          <label for="checkOption4"><span class="colorBall completed"></span>완료</label>
                        </div>
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="statusFilter" id="checkOption5" checked>
                          <label for="checkOption5"><span class="colorBall onHold"></span>보류</label>
                        </div>
                      </div>
                    </div>
                    <div :class="['filterPanelItemBox priorityFilter', isPriorityCatgoryOpen ? 'active' : '']"> 
                      <div class="filterPanelItemTitle" @click="togglePriorityCategoryFilter">
                        <span>우선순위</span>
                        <i class="bi bi-chevron-up"></i>
                      </div>
                      <div class="filterPanelItemList">
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="priorityFilter" id="checkOption6" checked>
                          <label for="checkOption6"><i class="bi bi-fire"></i>긴급</label>
                        </div>
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="priorityFilter" id="checkOption7" checked>
                          <label for="checkOption7"><i class="bi bi-caret-up-fill"></i>높음</label>
                        </div>
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="priorityFilter" id="checkOption8" checked>
                          <label for="checkOption8"><i class="bi bi-caret-right-fill"></i>보통</label>
                        </div>
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="priorityFilter" id="checkOption9" checked>
                          <label for="checkOption9"><i class="bi bi-caret-down-fill"></i>낮음</label>
                        </div>
                        <div class="filterInputItem checkBoxItem">
                          <input type="checkbox" name="priorityFilter" id="checkOption10" checked>
                          <label for="checkOption10">없음</label>
                        </div>
                      </div>
                    </div>
                    <div :class="['filterPanelItemBox', isStartDateCatgoryOpen ? 'active' : '']"> 
                      <div class="filterPanelItemTitle" @click="toggleStartDateCategoryFilter">
                        <span>시작일</span>
                        <i class="bi bi-chevron-up"></i>
                      </div>
                      <div class="filterPanelItemList">
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="startDateFilter" id="radioOption4">
                          <label for="radioOption4">전체</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="startDateFilter" id="radioOption5">
                          <label for="radioOption5">오늘</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="startDateFilter" id="radioOption6">
                          <label for="radioOption6">이번 주</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="startDateFilter" id="radioOption7">
                          <label for="radioOption7">이번 달</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="startDateFilter" id="radioOption8">
                          <label for="radioOption8">미정</label>
                        </div>
                      </div>
                    </div>
                    <div :class="['filterPanelItemBox', isEndDateCatgoryOpen ? 'active' : '']"> 
                      <div class="filterPanelItemTitle" @click="toggleEndDateCategoryFilter">
                        <span>마감일</span>
                        <i class="bi bi-chevron-up"></i>
                      </div>
                      <div class="filterPanelItemList">
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="endDateFilter" id="radioOption9">
                          <label for="radioOption9">전체</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="endDateFilter" id="radioOption10">
                          <label for="radioOption10">지연</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="endDateFilter" id="radioOption11">
                          <label for="radioOption11">오늘</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="endDateFilter" id="radioOption12">
                          <label for="radioOption12">이번 주</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="endDateFilter" id="radioOption13">
                          <label for="radioOption13">이번 달</label>
                        </div>
                        <div class="filterInputItem radioItem">
                          <input type="radio" name="endDateFilter" id="radioOption14">
                          <label for="radioOption14">미정</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="filterPanelBtn" @click="toggleFilter">
                  <span>필터</span>
                  <i class="bi bi-chevron-right"></i>
                </div>  
              </div>
              <div class="projectListHeaderLeft">
                <div class="projectSearch formRightIcon" @click="showAlert">
                  <input type="search" name="projectSearch" id="projectSearch" placeholder="업무명 또는 업무번호를 검색해주세요" >
                  <span class="formIcon">
                    <i class="bi bi-search"></i>
                  </span>
                </div>
              </div>
              <div class="projectListHeaderRight">
                <div class="checkBoxContainer openAllCheckBox">
                  <input type="checkbox" id="openAll" v-model="openAll">
                  <label for="openAll">모두 펼치기</label>
                </div>
                <div class="excelBtnBox">
                  <button class="biglineBtn" @click="showAlert">
                    <i class="bi bi-table"></i>
                    <span>엑셀 다운로드</span>
                  </button>
                </div>
                <div class="addListBtnBox" ref="addListBox">
                  <button class="biglineBtn blueBtn" @click="toggleTaskAddDropdownFilter">
                    <span>업무 추가</span>
                    <i class="bi bi-chevron-down"></i>
                  </button>
                  <!-- ▼ 업무 추가 chevron 클릭 시 class="active" 추가 -> 나타남 -->                  
                  <div :class="['modalDropdownBox', isTaskAddDropdownOpen ? 'active' : '']"> 
                    <div class="modalDropdownItem" @click="showAddTaskPopup = true">업무 추가</div>
                    <div class="modalDropdownItem" @click="showAlert">그룹 추가</div>
                  </div>
                </div>
                <div class="SetBtnBox">
                  <button class="biglineBtn" @click="toggleSettingFilter">
                    <i class="bi bi-search"></i>
                    <span>설정</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="projectListBody">
              <table>
                <thead>
                  <template v-for="col in taskListOrder" :key="col.settingKey">
                    <th v-if="col.viewYN === 'Y'"
                        :style="{ width: taskViewColumnWidths[col.settingKey] + 'px' }">
                      {{ col.settingLabel }}
                    </th>
                  </template>                  
                  <th></th>
                </thead>
                <tbody>
                  <!-- 그룹지정???????? -->
                  <!-- <tr class="groupRow">
                    <td colspan="12" class="projectGroupRow">
                      <div>
                        <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                        <div class="projectGroupRowTitleBox groupProjectListItem">
                          <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                          <div class="projectGroupRowTitle">그룹명<span>(1)</span></div>
                          <div class="extraBtnBox">
                            <button class="lineBtn">
                              <span>업무추가</span>
                            </button>
                            <div class="trashCan"><i class="bi bi-trash3"></i></div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="projectListTitleBox">
                      <div class="projectListTitleContainer">
                        <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                        <div class="projectListTitle">
                          <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                          <span>업무명</span>
                          <div class="extraBtnBox">
                              <button class="lineBtn">
                                <span>업무추가</span>
                              </button>
                          </div>
                        </div>
                        <div><span class="underlineBtn">자세히 보기</span></div>  
                      </div>
                    </td>
                    <td class="projectListStatus"><div><span class="statusBtnSmall request">요청</span></div></td>
                    <td class="projectListPriorityBox">-</td>
                    <td>-</td>
                    <td>2025-07-07</td>
                    <td>2025-07-30</td>
                    <td>26</td>
                    <td>홍길동</td>
                    <td>2025-07-06</td>
                    <td>2025-07-23</td>
                    <td>
                      <div class="progressBox">
                        <div>
                          <progress max="100" value="100" style="width: 60px;"></progress>
                        </div>
                        <span>100%</span>
                      </div>
                    </td>
                    <td></td>
                  </tr> -->
                  <tr class="groupRow">
                    <td colspan="12" class="projectGroupRow">
                      <div>
                        <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                        <div class="projectGroupRowTitleBox groupProjectListItem">
                          <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                          <div class="projectGroupRowTitle">그룹 미지정<span>({{ taskList.length }})</span></div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <template v-for="task in taskList" :key="task.taskId">
                     <tr v-show="openAll">
                      <template v-for="col in taskListOrder" :key="col.settingKey">
                        <td v-if="col.viewYN === 'Y'">
                          <!-- 업무명 -->
                          <div v-if="col.settingKey === 'subject'" class="projectListTitleBox">
                            <div class="projectListTitleContainer">
                              <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                              <div class="projectListTitle">
                                <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                                <span>{{ task.subject }}</span>
                                <div class="extraBtnBox" @click="showAlert">
                                  <button class="lineBtn"><span>업무추가</span></button>
                                </div>
                              </div>
                              <div><span class="underlineBtn" @click="showTaskDetail(task.taskId)">자세히 보기</span></div>
                            </div>
                          </div>
                          <!-- 상태 -->
                          <div v-else-if="col.settingKey === 'status'" class="projectListStatus">
                            <span class="statusBtnSmall" :class="taskListStatusMap[task.status]?.class">
                              {{ taskListStatusMap[task.status]?.text || task.status }}
                            </span>
                          </div>
                          <!-- 우선순위 -->
                          <div v-else-if="col.settingKey === 'priority'" class="projectListPriorityBox">
                            <div class="simpleBtn" :class="taskListPriorityMap[task.priority.trim()]?.class">
                              <i :class="taskListPriorityMap[task.priority.trim()]?.icon"></i>
                              <span>{{ taskListPriorityMap[task.priority.trim()]?.text.trim() }}</span>
                            </div>
                          </div>
                          <!-- 담당자 -->
                          <span v-else-if="col.settingKey === 'manager'">{{ task.managerUserName }}</span>
                          <!-- 시작일 -->
                          <span v-else-if="col.settingKey === 'start_date'">{{ task.startDate }}</span>
                          <!-- 마감일 -->
                          <span v-else-if="col.settingKey === 'end_date'">{{ task.endDate }}</span>
                          <!-- 업무번호 -->
                          <span v-else-if="col.settingKey === 'task_no'">{{ task.taskId }}</span>
                          <!-- 작성자 -->
                          <span v-else-if="col.settingKey === 'created_user'">{{ task.createdUserName }}</span>
                          <!-- 등록일 -->
                          <span v-else-if="col.settingKey === 'created_dtm'">{{ formatDateYYYYMMDD(task.createdDtm) }}</span>
                          <!-- 수정일 -->
                          <span v-else-if="col.settingKey === 'updated_dtm'">{{ formatDateYYYYMMDD(task.updatedDtm) }}</span>
                          <!-- 진척도 -->
                          <div v-else-if="col.settingKey === 'progress_num'" class="progressBox">
                            <progress max="100" :value="task.progressNum" style="width: 60px;"></progress>
                            <span>{{ task.progressNum }}%</span>
                          </div>                          
                        </td>
                      </template>
                      <td></td>                      
                    </tr>

                    <!-- 하위업무가 있을 경우 -->
                    <tr v-for="sub in (task.subTaskList || [])" :key="sub.subTaskId" v-show="openAll">
                      <template v-for="col in taskListOrder" :key="col.settingKey">
                        <td v-if="col.viewYN === 'Y'">
                          <!-- 업무명 -->
                          <div v-if="col.settingKey === 'subject'" class="projectListTitleBox">
                            <div class="projectListTitleContainer">
                              <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                              <div class="projectListTitle groupProjectListItem">
                                <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                                <span>{{ sub.subTaskSubject }}</span>
                                <div class="extraBtnBox" @click="showAlert">
                                  <button class="lineBtn"><span>업무추가</span></button>
                                </div>
                              </div>
                              <div><span class="underlineBtn"></span></div>
                            </div>
                          </div>
                          <!-- 상태 -->
                          <div v-else-if="col.settingKey === 'status'" class="projectListStatus">
                            <span class="statusBtnSmall" :class="statusMap[sub.subTaskStatus]?.class">
                              {{ statusMap[sub.subTaskStatus]?.text }}
                            </span>
                          </div>
                          <!-- 우선순위 -->
                          <div v-else-if="col.settingKey === 'priority'" class="projectListPriorityBox">
                            <div class="simpleBtn" :class="taskListPriorityMap[sub.subTaskPriority.trim()]?.class">
                              <i :class="taskListPriorityMap[sub.subTaskPriority.trim()]?.icon"></i>
                              <span>{{ taskListPriorityMap[sub.subTaskPriority.trim()]?.text.trim() }}</span>
                            </div>
                          </div>
                          <!-- 담당자 -->
                          <span v-else-if="col.settingKey === 'manager'">{{ sub.subTaskManagerUserName }}</span>
                          <!-- 시작일 -->
                          <span v-else-if="col.settingKey === 'start_date'">{{ task.startDate }}</span>
                          <!-- 마감일 -->
                          <span v-else-if="col.settingKey === 'end_date'" >{{ sub.subTaskEndDate }}</span>
                          <!-- 업무번호 -->
                          <span v-else-if="col.settingKey === 'task_no'">{{ sub.taskId }}</span>
                          <!-- 작성자 -->
                          <span v-else-if="col.settingKey === 'created_user'">{{ sub.subTaskCreatedUserName }}</span>
                          <!-- 등록일 -->
                          <span v-else-if="col.settingKey === 'created_dtm'">{{ formatDateToYYYYMMDD(sub.subTaskCreatedDtm) }}</span>
                          <!-- 수정일 -->
                          <span v-else-if="col.settingKey === 'updated_dtm'">{{ formatDateToYYYYMMDD(sub.subTaskUpdatedDtm) }}</span>
                          <!-- 진척도 -->
                          <span v-else-if="col.settingKey === 'progress_num'">-</span>
                        </td>
                      </template>
                      <td></td>
                    </tr>
                  </template>
                  <!-- <tr>
                    <td class="projectListTitleBox">
                      <div class="projectListTitleContainer">
                        <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                        <div class="projectListTitle">
                          <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                          <span>업무명</span>
                          <div class="extraBtnBox">
                              <button class="lineBtn">
                                <span>업무추가</span>
                              </button>
                          </div>
                        </div>
                        <div><span class="underlineBtn">자세히 보기</span></div>  
                      </div>
                    </td>
                    <td class="projectListStatus"><div><span class="statusBtnSmall request">요청</span></div></td>
                    <td class="projectListPriorityBox">-</td>
                    <td>-</td>
                    <td>2025-07-07</td>
                    <td>2025-07-30</td>
                    <td>26</td>
                    <td>홍길동</td>
                    <td>2025-07-06</td>
                    <td>2025-07-23</td>
                    <td>
                      <div class="progressBox">
                        <div>
                          <progress max="100" value="100" style="width: 60px;"></progress>
                        </div>
                        <span>100%</span>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="projectListTitleBox">
                      <div class="projectListTitleContainer">
                        <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                        <div class="projectListTitle groupProjectListItem">
                          <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                          <span>업무명</span>
                          <div class="extraBtnBox">
                              <button class="lineBtn">
                                <span>업무추가</span>
                              </button>
                          </div>
                        </div>
                        <div><span class="underlineBtn">자세히 보기</span></div>  
                      </div>
                    </td>
                    <td class="projectListStatus"><div><span class="statusBtnSmall inProgress">진행</span></div></td>
                    <td class="projectListPriorityBox">-</td>
                    <td>-</td>
                    <td>2025-07-07</td>
                    <td>2025-07-30</td>
                    <td>26</td>
                    <td>홍길동</td>
                    <td>2025-07-06</td>
                    <td>2025-07-23</td>
                    <td>
                      <div class="progressBox">
                        <div>
                          <progress max="100" value="80" style="width: 60px;"></progress>
                        </div>
                        <span>80%</span>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="projectListTitleBox">
                      <div class="projectListTitleContainer">
                        <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                        <div class="projectListTitle subTaskTableListItem">
                          <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                          <span>업무명</span>
                          <div class="extraBtnBox">
                              <button class="lineBtn">
                                <span>업무추가</span>
                              </button>
                          </div>
                        </div>
                        <div><span class="underlineBtn">자세히 보기</span></div>  
                      </div>
                    </td>
                    <td class="projectListStatus"><div><span class="statusBtnSmall feedback">피드백</span></div></td>
                    <td class="projectListPriorityBox">
                      <div class="simpleBtn priority1">
                        <i class="bi bi-fire"></i>
                        <span>긴급</span>
                      </div>
                    </td>
                    <td>-</td>
                    <td>2025-07-07</td>
                    <td class="timeOver">2025-07-10</td>
                    <td>26</td>
                    <td>홍길동</td>
                    <td>2025-07-06</td>
                    <td>2025-07-23</td>
                    <td>
                      <div class="progressBox">
                        <div>
                          <progress max="100" value="60" style="width: 60px;"></progress>
                        </div>
                        <span>60%</span>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="projectListTitleBox">
                      <div class="projectListTitleContainer">
                        <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                        <div class="projectListTitle subTaskTableListItem">
                          <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                          <span>업무명</span>
                          <div class="extraBtnBox">
                              <button class="lineBtn">
                                <span>업무추가</span>
                              </button>
                          </div>
                        </div>
                        <div><span class="underlineBtn">자세히 보기</span></div>  
                      </div>
                    </td>
                    <td class="projectListStatus"><div><span class="statusBtnSmall completed">완료</span></div></td>
                    <td class="projectListPriorityBox">
                      <div class="simpleBtn priority2">
                        <i class="bi bi-caret-up-fill"></i>
                        <span>높음</span>
                      </div>
                    </td>
                    <td>홍길동</td>
                    <td>2025-07-07</td>
                    <td class="timeOver">2025-07-10</td>
                    <td>26</td>
                    <td>홍길동</td>
                    <td>2025-07-06</td>
                    <td>2025-07-23</td>
                    <td>
                      <div class="progressBox">
                        <div>
                          <progress max="100" value="40" style="width: 60px;"></progress>
                        </div>
                        <span>40%</span>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="projectListTitleBox">
                      <div class="projectListTitleContainer">
                        <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                        <div class="projectListTitle subTaskTableListItem">
                          <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                          <span>업무명</span>
                          <div class="extraBtnBox">
                              <button class="lineBtn">
                                <span>업무추가</span>
                              </button>
                          </div>
                        </div>
                        <div><span class="underlineBtn">자세히 보기</span></div>  
                      </div>
                    </td>
                    <td class="projectListStatus"><div><span class="statusBtnSmall onHold">보류</span></div></td>
                    <td class="projectListPriorityBox">
                      <div class="simpleBtn priority3">
                        <i class="bi bi-caret-right-fill"></i>
                        <span>보통</span>
                      </div>
                    </td>
                    <td>홍길동</td>
                    <td>2025-07-07</td>
                    <td>2025-07-30</td>
                    <td>26</td>
                    <td>홍길동</td>
                    <td>2025-07-06</td>
                    <td>2025-07-23</td>
                    <td>
                      <div class="progressBox">
                        <div>
                          <progress max="100" value="20" style="width: 60px;"></progress>
                        </div>
                        <span>20%</span>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="projectListTitleBox">
                      <div class="projectListTitleContainer">
                        <div class="grap"><i class="bi bi-grip-vertical"></i></div>
                        <div class="projectListTitle subTaskTableListItemLast">
                          <span class="listToggleIcon"><i class="bi bi-caret-down-fill"></i></span>
                          <span>업무명</span>
                          <div class="extraBtnBox">
                              <button class="lineBtn">
                                <span>업무추가</span>
                              </button>
                          </div>
                        </div>
                        <div><span class="underlineBtn">자세히 보기</span></div>  
                      </div>
                    </td>
                    <td class="projectListStatus"><div><span class="statusBtnSmall request">요청</span></div></td>
                    <td class="projectListPriorityBox">
                      <div class="simpleBtn priority4">
                        <i class="bi bi-caret-down-fill"></i>
                        <span>낮음</span>
                      </div>
                    </td>
                    <td>홍길동</td>
                    <td>2025-07-07</td>
                    <td>2025-07-30</td>
                    <td>26</td>
                    <td>홍길동</td>
                    <td>2025-07-06</td>
                    <td>2025-07-23</td>
                    <td>
                      <div class="progressBox">
                        <div>
                          <progress max="100" value="0" style="width: 60px;"></progress>
                        </div>
                        <span>0%</span>
                      </div>
                    </td>
                    <td></td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </div>
      </div>
    </div>

      <!-- 글 작성 모달 -->
      <div class="modalBg createTextFeed " v-show="showAddPostPopup">
          <div class="modalBox createTextFeedBox">
              <div class="modalHeader">
                  <div class="modalTitleBox">
                      <div class="modalTitle">
                          <h5>게시물 작성</h5>
                          <span class="gap"></span>
                          <span class="modalchangeProjectBox">
                              <i class="bi bi-chevron-down"></i>
                              <div class="selectedProject">
                                  <i class="bi bi-app"></i><span>{{this.projectName}}</span>
                              </div>
                          </span>
                      </div>
                      <div class="modalHeaderBtnBox">
                          <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                          <span class="closeBtn" @click="showAddPostPopup = false;initPostPopupVaule();"><i class="bi bi-x-lg"></i></span>
                      </div>
                  </div>
                  <div class="modalMenu">
                      <div class="selectCategory">
                          <div class="simpleBtn simple55Btn active" @click="initAllPopup('post')">
                              <i class="bi bi-file-earmark-text"></i>
                              <span>글</span>
                          </div>
                          <div class="simpleBtn simple55Btn" @click="initAllPopup('task')">
                              <i class="bi bi-card-list"></i>
                              <span>업무</span>
                          </div>
                          <div class="simpleBtn simple55Btn" @click="initAllPopup('schedule')">
                              <i class="bi bi-calendar-week"></i>
                              <span>일정</span>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="modalBody">
                  <div class="modalFeedTitleInputBox">
                      <input type="text" class="modalFeedTitleInput" v-model="postSubject" ref="postSubject" placeholder="제목을 작성하세요." >
                  </div>
                  <div class="modalFeedDesInputBox">
                      <textarea name="" id="" class="modalFeedDesInput" v-model="postContent" ref="postContent" placeholder="내용을 작성하세요."></textarea>
                  </div>
              </div>
              <div class="modalFooter">
                  <div class="modalFooterBtnBox">
                      <div class="btnBox">
                          <i class="bi bi-fonts"></i>
                          <i class="bi bi-paperclip"></i>
                          <i class="bi bi-geo-alt"></i>
                      </div>
                  </div>
                  <div class="modalFooterBtnBox">
                      <div class="dropdown">
                          <div class="dropdown-button" @click="toggleDropdown">{{ selectedOption }}</div>
                          <div class="dropdown-menu" v-show="isDropdownOpen">
                              <div class="dropdown-item" @click="selectItem('전체공개')">전체공개</div>
                              <div class="dropdown-item" @click="selectItem('프로젝트 관리자만')">프로젝트 관리자만</div>
                          </div>
                      </div>
                      <div class="preStorage">
                          <span>임시저장</span>
                          <span class="gap"></span>
                          <span><b>0</b></span>
                      </div>
                      <button class="blueBtn" @click="addPost">등록</button>
                  </div>
              </div>
          </div>
      </div>                

      <!-- 업무 작성 모달 : .active -->
      <div class="modalBg createTaskFeed " v-show="showAddTaskPopup">
          <div class="modalBox createTaskFeedBox">
              <div class="modalHeader">
                  <div class="modalTitleBox">
                      <div class="modalTitle">
                          <h5>게시물 작성</h5>
                          <span class="gap"></span>
                          <span class="modalchangeProjectBox">
                              <i class="bi bi-chevron-down"></i>
                              <div class="selectedProject">
                                  <i class="bi bi-app"></i><span>{{this.projectName}}</span>
                              </div>
                          </span>
                      </div>
                      <div class="modalHeaderBtnBox">
                          <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                          <span class="closeBtn" @click="showAddTaskPopup = false;initTaskPopupVaule();"><i class="bi bi-x-lg"></i></span>
                      </div>
                  </div>
                  <div class="modalMenu">
                      <div class="selectCategory">
                          <div class="simpleBtn simple55Btn" @click="initAllPopup('post')">
                              <i class="bi bi-file-earmark-text"></i>
                              <span>글</span>
                          </div>
                          <div class="simpleBtn simple55Btn active" @click="initAllPopup('task')">
                              <i class="bi bi-card-list"></i>
                              <span>업무</span>
                          </div>
                          <div class="simpleBtn simple55Btn" @click="initAllPopup('schedule')">
                              <i class="bi bi-calendar-week"></i>
                              <span>일정</span>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="modalBody">
                  <div class="modalFeedTitleInputBox">
                      <input type="text" class="modalFeedTitleInput" v-model="taskSubject" ref="taskSubject" placeholder="제목을 작성하세요.">
                  </div>
                  <div class="modalFeedDetailItemBox">

                      <div class="detailItem status">
                          <div class="detailItemIcon">
                              <i class="bi bi-bar-chart-steps"></i>
                          </div>
                          <div class="detailItemDes">
                              <div class="statusBtnBox">
                                  <div class="statusBtn request" :class="{ active: selectedTaskStatus === 'R' }" @click="selectedTaskStatus = 'R'">요청</div>
                                  <div class="statusBtn inProgress" :class="{ active: selectedTaskStatus === 'P' }" @click="selectedTaskStatus = 'P'">진행</div>
                                  <div class="statusBtn feedback" :class="{ active: selectedTaskStatus === 'F' }" @click="selectedTaskStatus = 'F'">피드백</div>
                                  <div class="statusBtn completed" :class="{ active: selectedTaskStatus === 'C' }" @click="selectedTaskStatus = 'C'">완료</div>
                                  <div class="statusBtn onHold" :class="{ active: selectedTaskStatus === 'H' }" @click="selectedTaskStatus = 'H'">보류</div>
                              </div>
                          </div>
                      </div>

                      <div class="detailItem manager">
                          <div class="detailItemIcon">
                              <i class="bi bi-person"></i>
                          </div>
                          <div class="flexAlignCenter">
                              <!-- ▼ 담당자 추가 시 생성 ▼ -->
                              <div class="detailItemDes" v-if="selectedTaskManager">
                                  <div class="selectedUser">
                                      <div class="userInfo">
                                          <div class="specialUserImg">
                                              <img :src="selectedTaskManager.managerUserPhoto ? 
                                              `https://mizecloud-partners.co.kr/employee_img/${selectedTaskManager.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'" alt="userProfileImg"/>
                                          </div>
                                          <div class="specialUserName">{{ selectedTaskManager.managerUserName }}</div>
                                      </div>
                                      <span class="xBtn" @click="selectedTaskManager = ''"><i class="bi bi-x-lg"></i></span>
                                  </div>
                              </div>
                              <span class="underlineBtn" @click="searchManagerName = ''; isManagerPopupOpen = !isManagerPopupOpen" v-if="!selectedTaskManager">담당자 추가</span>
                              <!-- ▼ 담당자 추가 시 class="active" 추가 -> 나타남 -->
                              <div class="peopleSelectBox" :class="{ active: isManagerPopupOpen }">
                                  <div class="peopleSearch formRightIcon">
                                      <input type="text" :value="searchManagerName" @input="handleManagerInput" id="peopleSearch" placeholder="검색어를 입력해주세요"/>
                                      <span class="formIcon">
                                          <i class="bi bi-search"></i>
                                      </span>
                                  </div>
                                  <div class="peopleListBox">
                                  <div class="peopleList" ref="peopleList">
                                      <div class="peopleItem" v-for="person in searchManagerUserList" :key="person.managerUserId" @click="selectTaskManager(person)">
                                          <div class="specialUserInfo">
                                          <div class="specialUserImg">
                                              <img
                                                  :src="
                                                  person.managerUserPhoto
                                                      ? `https://mizecloud-partners.co.kr/employee_img/${person.managerUserPhoto}`
                                                      : 'https://mizecloud-partners.co.kr/employee_img/default.png'
                                                  "
                                                  alt="profileImg"
                                              />
                                          </div>
                                          <div class="specialUserDes">
                                              <div class="specialUserName">
                                              {{ person.managerUserName }} <span>{{ person.managerUserPosition }}</span>
                                              </div>
                                              <div class="specialUserTeam">{{ person.managerUserDept }}</div>
                                          </div>
                                          </div>
                                      </div>
                                      <div v-if="searchManagerUserList.length === 0 && searchManagerName.trim() !== ''" class="noResult">
                                          검색 결과가 없습니다.
                                      </div>
                                  </div>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                      <div class="detailItem startDate">
                          <div class="detailItemIcon">
                              <i class="bi bi-calendar"></i>
                          </div>
                          <div class="flexAlignCenter">
                              <!-- ▼ 시작일 추가 시 생성 ▼ -->
                              <div class="detailItemDes" v-if="selectedTaskStartDate">
                                  <div class="textBox">
                                      <span>{{ formattedTaskStartDate }}</span>
                                      <span class="xBtn" @click="selectedTaskStartDate = null"><i class="bi bi-x-lg"></i></span>
                                  </div>
                              </div>
                              <span class="underlineBtn" @click="isTaskStartDatePickerOpen = true" v-if="!selectedTaskStartDate">시작일 추가</span>
                              <DatePicker
                                  :value="selectedTaskStartDate"
                                  @change="handleTaskStartDateChange"
                                  v-model:open="isTaskStartDatePickerOpen"
                              >
                                  <template #input></template>                        
                                  <template #icon-calendar></template>
                              </DatePicker>
                          </div>
                      </div>
                      
                      <div class="detailItem endDate">
                          <div class="detailItemIcon">
                              <i class="bi bi-calendar"></i>
                          </div>
                          <div class="flexAlignCenter">
                              <!-- ▼ 마감일 추가 시 생성 ▼ -->
                              <div class="detailItemDes" v-if="selectedTaskEndDate">
                                  <div class="textBox">
                                      <span>{{ formattedTaskEndDate }}</span>
                                      <span class="xBtn" @click="selectedTaskEndDate = null"><i class="bi bi-x-lg"></i></span>
                                  </div>
                              </div>
                              <span class="underlineBtn" @click="isTaskEndDatePickerOpen = true" v-if="!selectedTaskEndDate">마감일 추가</span>
                              <DatePicker
                                  :value="selectedTaskEndDate"
                                  @change="handleTaskEndDateChange"
                                  v-model:open="isTaskEndDatePickerOpen"
                              >
                                  <template #input></template>                        
                                  <template #icon-calendar></template>
                              </DatePicker>
                          </div>
                      </div>

                      <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                      <div class="detailItem priority" v-if="isPriorityProgressOpen">
                          <div class="detailItemIcon">
                              <i class="bi bi-flag"></i>
                          </div>
                          <div class="flexAlignCenter">
                              <!-- ▼ 우선순위 추가 시 생성 ▼ -->
                              <div class="detailItemDes" v-if="selectedPriority">
                                  <div class="textBox">
                                      <span class="simpleBtn notBtn" :class="selectedPriority.class">
                                          <i class="bi" :class="selectedPriority.icon"></i>
                                          <span>{{ selectedPriority.text }}</span>
                                      </span>
                                      <span class="xBtn" @click="selectedPriority = null; isPriorityPopupOpen = false;">
                                          <i class="bi bi-x-lg"></i>
                                      </span>
                                  </div>
                              </div>
                              <span class="underlineBtn" @click="isPriorityPopupOpen = true" v-if="!selectedPriority">우선순위 추가</span>
                              <!-- ▼ 우선순위 추가 시 class="active" 추가 -> 나타남 -->
                              <div class="prioritySelectBox" :class="{ active: isPriorityPopupOpen }">
                                  <div 
                                      v-for="priority in priorities" 
                                      :key="priority.id"
                                      class="simpleBtn"
                                      :class="priority.class"
                                      @click="selectPriority(priority)"
                                  >
                                      <i class="bi" :class="priority.icon"></i>
                                      <span>{{ priority.text }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                      <div class="detailItem progress" v-if="isPriorityProgressOpen">
                          <div class="detailItemIcon">
                              <i class="bi bi-segmented-nav"></i>
                          </div>
                          <div class="flexAlignCenter">
                              <div class="detailItemDes">
                                  <div class="progressBox">
                                      <input type="range" min="0" max="100" :value="taskProgress" @input="updateTaskProgress" />
                                      <span>{{ taskProgress }}%</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="subTaskListBox">
                          <button class="biglineBtn" @click="isPriorityProgressOpen = true;" v-if="!isPriorityProgressOpen">
                              <i class="bi bi-plus-lg"></i>
                              <span>항목추가입력</span>
                          </button>
                      </div>
                  </div>
                  <div class="modalFeedDesInputBox">
                      <textarea name="" id="" class="modalFeedDesInput" v-model="taskContent" ref="taskContent" placeholder="내용을 작성하세요."></textarea>
                  </div>
                  <div class="">
                      <div class="feedBodySubTaskBox">
                          <div class="subTaskTitleBox">
                              <span class="subTaskIcon"><i class="bi bi-list-task"></i></span>
                              <span class="subTaskTitle">하위업무</span>
                          </div>
                          <div class="subTaskListBox">
                              <div class="subTaskListItem" v-for="subTask in subTaskList" :key="subTask.id">
                                  <div class="subTaskInfo">
                                      <span class="statusBtnSmall request">{{ statusMap[subTask.status] }}</span>
                                      <span class="subTaskTxt">
                                          <input type="text" v-model="subTask.name" placeholder="업무명 입력" @keyup.enter="handleEnter(subTask)" :ref="'subtask_' + subTask.id">
                                      </span>
                                  </div>
                                  <div class="subTaskInfo" style="position: relative;">
                                      <span class="circleBtn" @click="toggleDatePicker(subTask)">
                                          <i class="bi bi-calendar" :style="subTask.subTaskEndDate ? 'color: #007bff;' : ''"></i>
                                      </span>
                                      <span class="circleBtn" @click="togglePriorityPopup(subTask)">
                                          <i class="bi" :class="subTask.selectedSubTaskPriority ? subTask.selectedSubTaskPriority.icon : 'bi-caret-down-fill'"
                                          :style="{ color: subTask.selectedSubTaskPriority ? subTask.selectedSubTaskPriority.color : '' + ' !important' }"></i>
                                      </span>
                                      <span class="circleBtn" @click="toggleManagerPopup(subTask)">
                                          <img
                                              v-if="subTask.selectedSubTaskManager"
                                              :src="subTask.selectedSubTaskManager.managerUserPhoto ? `https://mizecloud-partners.co.kr/employee_img/${subTask.selectedSubTaskManager.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'"
                                              alt="profileImg"
                                              class="profile-thumbnail" style="border-radius: 50%;"
                                          />
                                          <i v-else class="bi bi-person"></i>
                                      </span>
                                      <span v-if="subTask.isDatePickerOpen">
                                          <DatePicker
                                              :value="subTask.subTaskEndDate"
                                              @change="subTask.subTaskEndDate = $event; subTask.isDatePickerOpen = false;"
                                              :teleport="true"
                                              :auto-apply="true"
                                              inline
                                          />
                                      </span>
                                      
                                      <div class="prioritySelectBox" v-if="subTask.isSubTaskPriorityPopupOpen" 
                                          style="position: absolute !important;top:100% !important;right:0 !important;z-index:9999 !important; display: block !important;">
                                          <div 
                                              v-for="priority in subTaskPriorities" 
                                              :key="priority.id"
                                              class="simpleBtn"
                                              :class="priority.class"
                                              @click="selectSubTaskPriority(subTask, priority)"
                                          >
                                              <i class="bi" :class="priority.icon"></i>
                                              <span>{{ priority.text }}</span>
                                          </div>
                                      </div>

                                      <div class="peopleSelectBox" v-if="subTask.isSubTaskManagerPopupOpen" 
                                          style="position: absolute !important;top:100% !important;right:0 !important;z-index:9999 !important; display: block !important;">
                                          <div class="peopleSearch formRightIcon">
                                              <input type="text" :value="searchManagerName" @input="handleManagerInput" id="peopleSearch" placeholder="검색어를 입력해주세요"/>
                                              <span class="formIcon">
                                                  <i class="bi bi-search"></i>
                                              </span>
                                          </div>
                                          <div class="peopleListBox">
                                              <div class="peopleList" ref="peopleList">
                                                  <div class="peopleItem" v-for="person in searchManagerUserList" :key="person.managerUserId" @click="selectSubTaskManager(subTask, person)">
                                                      <div class="specialUserInfo">
                                                          <div class="specialUserImg">
                                                              <img
                                                                  :src="person.managerUserPhoto ? `https://mizecloud-partners.co.kr/employee_img/${person.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'"
                                                                  alt="profileImg"
                                                              />
                                                          </div>
                                                          <div class="specialUserDes">
                                                              <div class="specialUserName">
                                                                  {{ person.managerUserName }} <span>{{ person.managerUserPosition }}</span>
                                                              </div>
                                                              <div class="specialUserTeam">{{ person.managerUserDept }}</div>
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <div v-if="searchManagerUserList.length === 0 && searchManagerName.trim() !== ''" class="noResult">
                                                      검색 결과가 없습니다.
                                                  </div>
                                              </div>
                                          </div>
                                      </div>

                                  </div>
                              </div>
                          </div>                        
                          <div class="subTaskListBox">
                              <button class="biglineBtn" @click="addSubTask">
                                  <i class="bi bi-plus-lg"></i>
                                  <span>하위업무 추가</span>
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="modalFooter">
                  <div class="modalFooterBtnBox">
                      <div class="btnBox">
                          <i class="bi bi-fonts"></i>
                          <i class="bi bi-paperclip"></i>
                          <i class="bi bi-geo-alt"></i>
                      </div>
                  </div>
                  <div class="modalFooterBtnBox">
                      <div class="dropdown">
                          <div class="dropdown-button" @click="toggleDropdown">{{ selectedOption }}</div>
                          <div class="dropdown-menu" v-show="isDropdownOpen">
                              <div class="dropdown-item" @click="selectItem('전체공개')">전체공개</div>
                              <div class="dropdown-item" @click="selectItem('프로젝트 관리자만')">프로젝트 관리자만</div>
                          </div>
                      </div>
                      <div class="preStorage">
                          <span>임시저장</span>
                          <span class="gap"></span>
                          <span><b>0</b></span>
                      </div>
                      <button class="blueBtn" @click="addTask">등록</button>
                  </div>
              </div>
          </div>
      </div>

      <!-- 일정 작성 모달 / 일정 추가 클릭시 .active -->
      <div class="modalBg createScheduleFeed" v-show="showAddSchedulePopup"> 
          <div class="modalBox createTextFeedBox">
              <div class="modalHeader">
                  <div class="modalTitleBox">
                      <div class="modalTitle">
                          <h5>게시물 작성</h5>
                          <span class="gap"></span>
                          <span class="modalchangeProjectBox">
                              <i class="bi bi-chevron-down"></i>
                              <div class="selectedProject">
                                  <i class="bi bi-app"></i><span>{{this.projectName}}</span>
                              </div>
                          </span>
                      </div>
                      <div class="modalHeaderBtnBox">
                          <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                          <span class="closeBtn" @click="showAddSchedulePopup = false;initSchedulePopupVaule();"><i class="bi bi-x-lg"></i></span>
                      </div>
                  </div>
                  <div class="modalMenu">
                      <div class="selectCategory">
                          <div class="simpleBtn simple55Btn" @click="initAllPopup('post')">
                              <i class="bi bi-file-earmark-text"></i>
                              <span>글</span>
                          </div>
                          <div class="simpleBtn simple55Btn" @click="initAllPopup('task')">
                              <i class="bi bi-card-list"></i>
                              <span>업무</span>
                          </div>
                          <div class="simpleBtn simple55Btn active" @click="initAllPopup('schedule')">
                              <i class="bi bi-calendar-week"></i>
                              <span>일정</span>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="modalBody">
                  <div class="modalFeedTitleInputBox">
                      <input type="text" class="modalFeedTitleInput" v-model="scheduleSubject" ref="scheduleSubject" placeholder="제목을 작성하세요.">
                  </div>
                  <div class="modalFeedDetailItemBox">

                      <div class="detailItem scheduleDateTime">
                          <div class="detailItemIcon">
                              <i class="bi bi-calendar"></i>
                          </div>
                          <div class="flexAlignCenter">
                              <div class="detailItemDes">
                                  <div class="dateBox">
                                      <input type="datetime-local" name="" id="startDateTime" v-model="scheduleStartDateTime" ref="scheduleStartDateTime" @input="handleScheduleStartDateChange">
                                      <span><i class="bi bi-dash-lg"></i></span>
                                      <input type="datetime-local" name="" id="endDateTime" v-model="scheduleEndDateTime" ref="scheduleEndDateTime" @input="handleScheduleEndDateChange">
                                  </div>
                              </div> 
                              <label class="checkboxBox" @click="checkAllDayClick">
                                  <input type="checkbox" name="" id="" v-model="isAllDay" :disabled="!canCheckAllDay" true-value="Y" false-value="N">
                                  <span>종일</span>
                              </label>
                          </div>
                      </div>

                      <div class="detailItem manager">
                          <div class="detailItemIcon">
                              <i class="bi bi-person"></i>
                          </div>
                          <div class="flexAlignCenter">
                              <div class="detailItemDes" v-if="selectedParticipantUserList.length">
                                  <div class="selectedUser" v-for="(participantUser, index) in selectedParticipantUserList" :key="participantUser.managerUserId || index">
                                      <div class="userInfo">
                                          <div class="specialUserImg">
                                              <img :src="participantUser.managerUserPhoto ? 
                                              `https://mizecloud-partners.co.kr/employee_img/${participantUser.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'" alt="userProfileImg"/>
                                          </div>
                                          <div class="specialUserName">{{ participantUser.managerUserName }}</div>
                                      </div>
                                      <span class="xBtn" @click="removeParticipant(index)"><i class="bi bi-x-lg"></i></span>
                                  </div>
                              </div>
                              <span class="underlineBtn"  @click="searchParticipantName = ''; isParticipantPopupOpen = !isParticipantPopupOpen">참석자 추가</span>
                              <!-- ▼ 담당자 추가 시 class="active" 추가 -> 나타남 -->
                              <div class="peopleSelectBox" :class="{ active: isParticipantPopupOpen }">
                                <div class="peopleSearch formRightIcon">
                                  <input type="text" :value="searchParticipantName" @input="handleParticipantInput" id="peopleSearch" placeholder="검색어를 입력해주세요"/>
                                  <span class="formIcon">
                                    <i class="bi bi-search"></i>
                                  </span>
                                </div>
                                <div class="peopleListBox">
                                  <div class="peopleList" ref="peopleList">
                                    <div class="peopleItem" v-for="person in searchParticipantUserList" :key="person.managerUserId" @click="selectScheduleParticipant(person)">
                                      <div class="specialUserInfo">
                                        <div class="specialUserImg">
                                          <img
                                              :src="
                                              person.managerUserPhoto
                                                  ? `https://mizecloud-partners.co.kr/employee_img/${person.managerUserPhoto}`
                                                  : 'https://mizecloud-partners.co.kr/employee_img/default.png'
                                              "
                                              alt="profileImg"
                                          />
                                        </div>
                                        <div class="specialUserDes">
                                          <div class="specialUserName">{{ person.managerUserName }} <span>{{ person.managerUserPosition }}</span></div>
                                          <div class="specialUserTeam">{{ person.managerUserDept }}</div>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="searchParticipantUserList.length === 0 && searchParticipantName.trim() !== ''" class="noResult">
                                        검색 결과가 없습니다.
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </div>
                      </div>

                      <div class="detailItem locate">
                          <div class="detailItemIcon">
                              <i class="bi bi-geo-alt"></i>
                          </div>
                          <div class="flexAlignCenter">
                              <div class="detailItemDes">
                                  <input type="text" v-model="scheduleLocation" ref="scheduleLocation" placeholder="장소를 입력하세요.">
                              </div>
                          </div>
                      </div>

                      
                      <!-- ▼ 줌 링크 추가 기능은 유료버전에만 해당되어 일단 항목만 넣어놓겠습니다 ▼ -->
                      <div class="detailItem zoomLink">
                          <div class="detailItemIcon">
                              <i class="bi bi-camera-video"></i>
                          </div>
                          <div class="flexAlignCenter">
                              <span class="underlineBtn" @click="showAlert()">화상회의 추가</span>
                          </div>
                      </div>

                      <div class="detailItem alretTime">
                          <div class="detailItemIcon">
                              <i class="bi bi-bell"></i>
                          </div>
                          <div class="flexAlignCenter">
                                  <select id="options" v-model="beforeAlarm">
                                      <option value="0">없음</option>
                                      <option value="10">10분 전 미리 알림</option>
                                      <option value="30">30분 전 미리 알림</option>
                                      <option value="60">1시간 전 미리 알림</option>
                                      <option value="120">2시간 전 미리 알림</option>
                                      <option value="180">3시간 전 미리 알림</option>
                                      <option value="1440">1일 전 미리 알림</option>
                                      <option value="2880">2일 전 미리 알림</option>
                                      <option value="10080">7일 전 미리 알림</option>
                                  </select>
                          </div>
                      </div>

                  </div>
                  <div class="modalFeedDesInputBox">
                      <textarea name="" id="" class="modalFeedDesInput" v-model="scheduleContent" ref="scheduleContent"  placeholder="내용을 작성하세요."></textarea>
                  </div>
              </div>
              <div class="modalFooter">
                  <div class="modalFooterBtnBox">
                      <div class="btnBox">
                          <i class="bi bi-fonts"></i>
                          <i class="bi bi-paperclip"></i>
                          <i class="bi bi-geo-alt"></i>
                      </div>
                  </div>
                  <div class="modalFooterBtnBox">
                      <div class="dropdown">
                          <div class="dropdown-button" @click="toggleDropdown">{{ selectedOption }}</div>
                          <div class="dropdown-menu" v-show="isDropdownOpen">
                              <div class="dropdown-item" @click="selectItem('전체공개')">전체공개</div>
                              <div class="dropdown-item" @click="selectItem('프로젝트 관리자만')">프로젝트 관리자만</div>
                          </div>
                      </div>
                      <div class="preStorage">
                        <span>임시저장</span>
                        <span class="gap"></span>
                        <span><b>0</b></span>
                      </div>
                      <button class="blueBtn" @click="addSchedule">등록</button>
                  </div>
              </div>
          </div>
      </div>

      <!-- 항목 클릭 시 업무 상세보기 : .active -->
      <div :class="showTaskDetailPopup ? 'specialSideModalBg detailViewProjectSideModal active' : 'specialSideModalBg detailViewProjectSideModal'" :key="taskDetailInfo.taskId">
        <div class="specialSideModalBox detailViewProject">
            <div class="projectListItem taskFeed">
              <div class="specialSideModalTitleBox">
                <div class="modalTitle">
                  <i class="bi bi-app"></i>
                  <h5>{{this.projectName}}</h5>
                </div>
                <div class="modalHeaderBtnBox">
                  <span class="closeBtn" @click="showTaskDetailPopup = false;"><i class="bi bi-x-lg"></i></span>
                </div>
              </div>
              <div class="feedListItemDes">
                <div class="feedListItemHeader">
                  <div class="writterInfo">
                    <div class="specialUserImg">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                    </div>
                  <div class="specialUserName">{{ taskDetailInfo.createdUserName }}</div>
                  <div class="writeTime">{{ taskDetailInfo.createdDtm }}</div>
                </div>
                <div class="feedHeaderBtnBox">
                  <div class="simpleBtn" @click="showAlert">
                    <i class="bi bi-pin"></i>
                  </div>
                  <div class="simpleBtn" @click="showAlert">
                    <i class="bi bi-three-dots-vertical"></i>
                  </div>
                </div>
              </div>
              <div class="feedListItemBody taskFeedItem">
                <div class="feedBodyTaskTitle">
                  <div class="feedBodyTitle">{{ taskDetailInfo.subject }}</div>
                  <span class="taskNumber biglineBtn">업무번호 {{ taskDetailInfo.taskId }}</span>    
                </div>
                <div class="feedBodyDetail">
                  <div class="detailItem status">
                    <div class="detailItemIcon">
                      <i class="bi bi-bar-chart-steps"></i>
                    </div>
                    <div class="detailItemDes">
                      <div class="statusBtnBox">
                        <!-- <div class="statusBtn request active">요청</div> -->
                        <div class="statusBtn" :class="taskListStatusMap[taskDetailInfo.status]?.class + ' active'">
                          {{ taskListStatusMap[taskDetailInfo.status]?.text }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="detailItem manager">
                    <div class="detailItemIcon">
                      <i class="bi bi-person"></i>
                    </div>
                    <div class="flexAlignCenter">
                      <div class="detailItemDes">
                        <div class="selectedUser">
                          <div class="userInfo">
                            <div class="specialUserImg">
                              <img
                                  :src="
                                  taskDetailInfo.managerUserPhoto
                                      ? `https://mizecloud-partners.co.kr/employee_img/${taskDetailInfo.managerUserPhoto}`
                                      : defaultProfileImg
                                  "
                                  alt="userProfileImg"
                              />
                            </div>
                            <div class="specialUserName">{{ taskDetailInfo.managerUserName }}</div>
                          </div>
                          <span class="xBtn" @click="showAlert"><i class="bi bi-x-lg"></i></span>
                        </div>
                      </div>
                      <span class="underlineBtn" @click="showAlert">담당자 변경</span>
                    </div>
                  </div>
                  <div class="detailItem endDate">
                    <div class="detailItemIcon">
                      <i class="bi bi-calendar"></i>
                    </div>
                  <div class="flexAlignCenter">
                    <div class="detailItemDes">
                      <div class="textBox">
                        <span>{{ taskDetailInfo.endDate }} ({{getWeekofDay(taskDetailInfo.endDate)}}) 까지</span>
                        <span class="xBtn" @click="showAlert"><i class="bi bi-x-lg"></i></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="subTaskListBox" @click="showAlert">
                  <button class="biglineBtn">
                    <i class="bi bi-plus-lg"></i>
                    <span>항목추가입력</span>
                  </button>
                </div>
              </div>
              <div class="feedBodyTextDetail">{{ taskDetailInfo.content }}</div>
                <div class="feedBodySubTaskBox">
                  <div class="subTaskTitleBox">
                    <span class="subTaskIcon"><i class="bi bi-list-task"></i></span>
                    <span class="subTaskTitle">하위업무</span>
                  </div>
                <div class="subTaskListBox">
                  <button class="biglineBtn" @click="showAlert">
                    <i class="bi bi-plus-lg"></i>
                    <span>하위업무 추가</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="feedListItemFooter">
              <div class="feedFooterLeft">
                <div class="simpleBtn" @click="likeFeed(taskDetailInfo)">
                  <i :class="taskDetailInfo.likeActiveYN === 'Y' ? 'bi bi-hand-thumbs-up-fill' : 'bi bi-hand-thumbs-up'"></i>
                  <span>좋아요</span>
                </div>
                <div class="simpleBtn" @click="likeBookmark(taskDetailInfo)">
                  <i :class="taskDetailInfo.bookmarkActiveYN === 'Y' ? 'bi bi-bookmark-fill' : 'bi bi-bookmark'"></i>
                  <span>북마크</span>
                </div>
                <div class="simpleBtn" @click="showAlert()">
                  <i class="bi bi-clock-history"></i>
                  <span>다시 알림</span>
                </div>
              </div>
              <div class="feedFooterRight">
                <div class="simpleBtn notBtn">
                  <span>읽음</span>
                  <span><b>1</b></span>
                </div>
              </div>
            </div>
          </div>

          <!-- 댓글 -->
          <div class="feedListItemComment">
              <div class="feedCommentHeader">
                  <span class="lineBtn active">
                      <span>전체</span>
                      <span><b>{{ taskDetailInfo.commentCount }}</b></span>
                  </span>
                  <span class="lineBtn">
                      <span>댓글</span>
                      <span><b>{{ taskDetailInfo.commentCount }}</b></span>
                  </span>
              </div>
              <div class="moreComment txtBtn"
                  v-if="taskDetailInfo.commentCount > initCommentViewCount"
                  @click="showMoreComments">
                이전 댓글 더보기 ({{ taskDetailInfo.commentCount - initCommentViewCount }})
              </div>
              <div class="feedCommentBody">
                  <div class="feedCommentItem noreply" v-for="comment in visibleComments" :key="comment.commentId">
                      <div class="commentLeft">
                          <img 
                              :src="comment.createdUserPhoto 
                                  ? `https://mizecloud-partners.co.kr/employee_img/${comment.createdUserPhoto}` 
                                  : 'https://mizecloud-partners.co.kr/employee_img/default.png'" 
                              alt="userProfileImg"
                          >
                      </div>
                      <div class="commentRight">
                          <div class="commentHeader">
                              <div class="commentHeaderUser">
                                  <div class="specialUserName">{{ comment.createdUserName }}</div>
                                  <div class="writeTime">{{ formatDate(comment.createdDtm) }}</div>
                              </div>
                              <div class="commentHeaderBtnBox">
                                  <div id="commentEdit" class="txtBtn" @click="showAlert()">수정</div>
                                  <div id="commentDelet" class="txtBtn" @click="showAlert()">삭제</div>
                              </div>
                          </div>
                          <div class="commentBody">
                              {{ comment.commentContent }}
                          </div>
                          <div class="commentFooter">
                              <div id="reply" class="simpleBtn" @click="showAlert()">
                                  <i class="bi bi-arrow-return-right"></i>
                                  <span>댓글</span>
                              </div>
                              <div id="like" class="simpleBtn" @click="likeFeedComment(comment)">
                                  <i :class="comment.commentLikeActiveYn === 'Y' ? 'bi bi-hand-thumbs-up-fill' : 'bi bi-hand-thumbs-up'"></i>
                                  <span>좋아요</span>
                              </div>
                          </div>
                      </div>
                  </div>                  
              </div>
              <div class="feedCommentFooter leaveComment">
                  <div class="leaveCommentUser">
                      <img :src="currentUserPhoto || defaultProfileImg" alt="userProfileImg">                                                  
                  </div>
                  <div class="leaveCommentInput formRightIcon">                      
                      <textarea 
                          type="text" 
                          v-model="newComment"
                          ref="newComment"
                          placeholder="줄바꿈 Shift + Enter / 입력 Enter 입니다."
                          @keyup.enter.exact="addComment(taskDetailInfo.taskId, 'T')"
                          @keyup.shift.enter="newLine"
                      ></textarea>
                      <span class="formIcon">
                      <i class="bi bi-paperclip" @click="showAlert()"></i>
                      </span>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
                
    <!-- 설정 : .active -->
    <div class="specialModalBg projectListSetModal" :class="{ active: isSettingPopupOpen }">
      <div class="specialModalBox createTextFeedBox ">
        <div class="specialModalHeader">
          <div class="specialModalTitleBox">
            <div class="specialModalTitle">
              <h5>보기 설정</h5>
            </div>
            <div class="specialModalHeaderBtnBox">
              <span class="closeBtn" @click="isSettingPopupOpen = false;"><i class="bi bi-x-lg"></i></span>
            </div>
          </div>
        </div>
        <div class="specialModalBody specialProjectListSetBody">
          <div class="specialProjectListSetTitle">
            <h5>항목 설정</h5>
            <div>항목 순서 변경과 조회할 항목을 선택할 수 있습니다.</div>
          </div>
          <div class="specialProjectListSetItemBox" ref="sortableList">
            <div class="specialSetItem" v-for="(item) in taskListOrder" :key="item.settingKey">
              <div class="specialNewProjectTypeSetTitle">
                <i class="bi bi-grip-vertical"></i>
                <span>{{ item.settingLabel }}</span>
              </div>
              <div class="specialToggleBtn">
                <input type="checkbox" class="toggleInput" :id="'toggle-' + item.settingKey" v-model="item.viewYN" true-value="Y" false-value="N" style="display:none"/>
                <label class="toggleLabel" :for="'toggle-' + item.settingKey"></label>
              </div>
            </div>
          </div>
        </div>
        <div class="specialModalFooter"> 
          <div class="specialModalFooterBtnBox">
            <button class="lineBtn" @click="initTaskListViewSetting">초기화</button>
            <button class="blueBtn" @click="addTaskListViewSetting">등록</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import apiClient from "@/apiClient";
import { useToast } from "vue-toastification";
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import Sortable from "sortablejs";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  props: ['projectId'],
  name: "ReportTask",
  components: { DatePicker },
  data() {
    return {
      subMenuGroups: [
        {
          title: "프로젝트 그룹 1",
          open: true,
          projects: ["프로젝트명 A", "프로젝트명 B", "프로젝트명 C"],
        },
        {
          title: "프로젝트 그룹 2",
          open: true,
          projects: ["프로젝트명 D", "프로젝트명 E"],
        },
      ],      
      showAddPostPopup: false,      // 글 작성 팝업
      showAddTaskPopup: false,      // 업무 작성 팝업
      showAddSchedulePopup: false,  // 일정 작성 팝업
      showTaskDetailPopup: false,   // 업무 상세보기 팝업
      projectInfo: [],              // 해당 프로젝트 정보
      projectName: '',              // 해당 프로젝트명
      selectedViewType: 'P',        // 전체공개여부 설정(default는 'P(Public)' => 전체공개 / 'A(Admin)' => 프로젝트 관리자만)
      alertMsg: {
        commingSoon:  '준비중입니다.',
        postSubject: '글 제목을 입력해주세요.',
        postContent: '글 내용을 입력해주세요.', 
        successPostAdd: '글 성공적으로 등록되었습니다.',
        failPostAdd: '글 등록 중 오류가 발생했습니다.',
        successTaskAdd: '업무가 성공적으로 등록되었습니다.',
        failTaskAdd: '업무 등록 중 오류가 발생했습니다.',
        successScheduleAdd: '일정이 성공적으로 등록되었습니다.',
        failScheduleAdd: '일정 등록 중 오류가 발생했습니다.',
        taskStartDateValid: '시작일은 마감일보다 이후일 수 없습니다.',
        taskEndDateValid: '마감일은 시작일보다 이전일 수 없습니다.',
        taskSubject: '업무 제목을 입력해주세요.',
        taskStatus: '업무 상태를 선택해주세요.',
        taskManager: '담당자를 추가해주세요.',
        taskStartDate: '시작일을 선택해주세요.',
        taskEndDate: '마감일을 선택해주세요.',
        taskContent: '업무 내용을 입력해주세요.',
        scheduleSubject:  '일정 제목을 입력해주세요.',
        scheduleStartDate: '일정 시작일을 선택해주세요.',
        scheduleEndDate: '일정 마감일을 선택해주세요.',
        scheduleContent:  '일정 내용을 입력해주세요.',
        scheduleParticipant: '참석자를 선택해주세요.',
        scheduleStartDateValidNow: '시작일은 현재시간보다 이후이어야 합니다.',
        scheduleStartDateValid: '시작일은 마감일보다 이후일 수 없습니다.',
        scheduleEndDateValidNow: '마감일은 현재시간보다 이후이어야 합니다.',
        scheduleEndDateValid: '마감일은 시작일보다 이전일 수 없습니다.',
        checkAllday: '시작일과 마감일을 먼저 선택해주세요.',
        successTaskViewSettingAdd: '업무보기 설정값이 성공적으로 등록되었습니다.',
        failTaskViewSettingAdd: '업무보기 설정값 등록 중 오류가 발생했습니다.',
        successLikeFeed: '해당 피드에 대해 좋아요 했습니다.',
        successUnLikeFeed: '해당 피드에 대해 좋아요 취소했습니다.',
        failLikeFeed: '해당 피드에 대해 좋아요 실패하였습니다.',
        successBookmarkFeed: '해당 피드에 대해 북마크 했습니다.',
        successUnBookmarkFeed: '해당 피드에 대해 북마크 취소했습니다.',
        failBookmarkFeed: '해당 피드에 대해 북마크 실패하였습니다.',
        successLikeFeedComment: '해당 댓글에 대해 좋아요 했습니다.',
        successUnLikeFeedComment: '해당 댓글에 대해 좋아요 취소했습니다.',
        failLikeFeedComment: '해당 댓글에 대해 좋아요 실패하였습니다.',
      },      
      currentUserPhoto: "https://mizecloud-partners.co.kr/employee_img/" + localStorage.getItem("userphoto"),            // 현재 사용자 프로필 이미지
      defaultProfileImg: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s", // 사용자 이미지 없는 경우 대체 이미지
      priorities: [
            { id: 4, text: '낮음', class: 'priority4', icon: 'bi-caret-down-fill', value: 'L'},
            { id: 3, text: '보통', class: 'priority3', icon: 'bi-caret-right-fill', value: 'M' },
            { id: 2, text: '높음', class: 'priority2', icon: 'bi-caret-up-fill', value: 'H' },
            { id: 1, text: '긴급', class: 'priority1', icon: 'bi-fire', value: 'U' }
      ],
      subTaskPriorities: [
            { id: 4, text: '낮음', class: 'priority4', icon: 'bi-caret-down-fill', color: 'var(--txt6)', value: 'L' },
            { id: 3, text: '보통', class: 'priority3', icon: 'bi-caret-right-fill', color: 'var(--mizeBlue)', value: 'M' },
            { id: 2, text: '높음', class: 'priority2', icon: 'bi-caret-up-fill', color: 'var(--pointYellow)', value: 'H' },
            { id: 1, text: '긴급', class: 'priority1', icon: 'bi-fire', color: 'var(--pointRed)', value: 'U' }
      ],
      statusMap: {
        'R': '요청',
        'P': '진행',
        'F': '피드백',
        'C': '완료',
        'H': '보류'
      },
      taskProgress: 0,
      isFilterOpen: false,              // 필터 팝업 상태
      isTaskCatgoryOpen: false,         // 필터 팝업 > 업무 구분
      isStatusCatgoryOpen: false,       // 필터 팝업 > 상태
      isPriorityCatgoryOpen: false,     // 필터 팝업 > 우선순위
      isStartDateCatgoryOpen: false,    // 필터 팝업 > 시작일
      isEndDateCatgoryOpen: false,      // 필터 팝업 > 종료일
      isSettingPopupOpen: false,        // 설정(보기 설정) 팝업 상태
      isTaskAddDropdownOpen: false,     // 업무추가 드롭다운 상태
      isDropdownOpen: false,
      selectedOption: "전체공개",      
      selectedTaskStatus: '',           // 업무작성 팝업 > 업무상태 => 요청 : R(Request) / 진행 : P(Progress) / 피드백 : F(Feedback) / 완료 : C(Completed) / 보류 : H(Hold)
      isTaskStartDatePickerOpen: false, // 업무작성 팝업 > 시작일 선택 팝업 오픈 여부
      isTaskEndDatePickerOpen: false,   // 업무작성 팝업 > 종료일 선택 팝업 오픈 여부
      isManagerPopupOpen: false,        // 담당자 추가
      isPriorityPopupOpen: false,       // 우선순위 추가
      isPriorityProgressOpen: false,    // 항목추가입력 클릭 시, 우선순위 & 진행률(%) 영역
      searchManagerName: "",            // 담당자 추가 시, 검색할 이름 입력값
      searchManagerUserList: [],        // 담당자 추가 시, 검색된 사용자 리스트
      selectedTaskManager: "",          // 업무작성 팝업 > 선택된 담당자 정보
      selectedTaskStartDate: null,      // 업무작성 팝업 > 선택된 시작일
      selectedTaskEndDate: null,        // 업무작성 팝업 > 선택된 마감일
      selectedPriority: null,           // 업무작성 팝업 > 선택된 우선순위
      subTaskList: [],                  // 업무작성 팝업 > 하위 업무 목록 배열

      isScheduleStartDatePickerOpen: false, // 일정작성 팝업 > 시작일 선택 팝업 오픈 여부
      isScheduleEndDatePickerOpen: false,   // 일정작성 팝업 > 종료일 선택 팝업 오픈 여부
      isParticipantPopupOpen: false,        // 참석자 추가
      searchParticipantName: "",            // 참석자 추가 시, 검색할 이름 입력값
      searchParticipantUserList: [],        // 참석자 추가 시, 검색된 사용자 리스트
      selectedParticipantUserList: [],      // 일정작성 팝업 > 선택된 참석자들 정보
      selectedScheduleStartDate: null,      // 일정작성 팝업 > 선택된 시작일
      selectedScheduleEndDate: null,        // 일정작성 팝업 > 선택된 마감일
      isAllDay: 'N',                        // 종일여부
      beforeAlarm: 0,                       // 미리알림(분단위)
      openAll: true,                        // 모두 펼치기 체크박스
      taskList: [],                         // DB로부터 가져온 업무 리스트 데이터
      taskDetailInfo: [],                   // 자세히보기 클릭 시, DB로부터 가져온 업무 상세 정보 데이터
      newComment: "",                       // 입력한 댓글
      initCommentViewCount: 5,              // 처음에 보여줄 댓글 카운트 
      moreCommentViewCount: 5,              // 이전댓글 더보기 클릭 시, 보여줄 댓글 카운트
      defaultTaskListOrder: [               // 설정(보기 설정) 팝업 > 항목 기본 설정
        { settingKey: 'subject', settingLabel: '업무명', viewYN: 'Y' },
        { settingKey: 'status', settingLabel: '상태', viewYN: 'Y' },
        { settingKey: 'priority', settingLabel: '우선순위', viewYN: 'Y' },
        { settingKey: 'manager', settingLabel: '담당자', viewYN: 'Y' },
        { settingKey: 'start_date', settingLabel: '시작일', viewYN: 'Y' },
        { settingKey: 'end_date', settingLabel: '마감일', viewYN: 'Y' },
        { settingKey: 'task_no', settingLabel: '업무번호', viewYN: 'Y' },
        { settingKey: 'created_user', settingLabel: '작성자', viewYN: 'Y' },
        { settingKey: 'created_dtm', settingLabel: '등록일', viewYN: 'Y' },
        { settingKey: 'updated_dtm', settingLabel: '수정일', viewYN: 'Y' },
        { settingKey: 'progress_num', settingLabel: '진척도', viewYN: 'Y' }
      ],
      taskListOrder: [                      // 설정(보기 설정) 팝업 > 항목
        { settingKey: "subject", settingLabel: "업무명", viewYN: "Y" },
        { settingKey: "status", settingLabel: "상태", viewYN: "Y" },
        { settingKey: "priority", settingLabel: "우선순위", viewYN: "Y" },
        { settingKey: "manager", settingLabel: "담당자", viewYN: "Y" },
        { settingKey: "start_date", settingLabel: "시작일", viewYN: "Y" },
        { settingKey: "end_date", settingLabel: "마감일", viewYN: "Y" },
        { settingKey: "task_no", settingLabel: "업무번호", viewYN: "Y" },
        { settingKey: "created_user", settingLabel: "작성자", viewYN: "Y" },
        { settingKey: "created_dtm", settingLabel: "등록일", viewYN: "Y" },
        { settingKey: "updated_dtm", settingLabel: "수정일", viewYN: "Y" },
        { settingKey: "progress_num", settingLabel: "진척도", viewYN: "Y" }
      ],   
      taskViewColumnWidths: {               // 사용자의 보기 설정 Width 값
        subject: 400,
        status: 90,
        priority: 100,
        manager: 100,
        start_date: 130,
        end_date: 130,
        task_no: 85,
        created_user: 100,
        created_dtm: 130,
        updated_dtm: 130,
        progress_num: 150
      },
      taskListStatusMap: {
        R: { class: 'request', text: '요청' },
        P: { class: 'inProgress', text: '진행' },
        F: { class: 'feedback', text: '피드백' },
        C: { class: 'completed', text: '완료' },
        H: { class: 'onHold', text: '보류' }
      },
      taskListPriorityMap: {
        'U': { class: 'priority1', icon: 'bi bi-fire', text: '긴급' },
        'H': { class: 'priority2', icon: 'bi bi-caret-up-fill', text: '높음' },
        'M': { class: 'priority3', icon: 'bi bi-caret-right-fill', text: '보통' },
        'L': { class: 'priority4', icon: 'bi bi-caret-down-fill', text: '낮음' },        
        '':  { class: '', icon: '', text: '-' },
        null:{ class: '', icon: '', text: '-' }
      },

    };
  },
  computed: {
        formattedTaskStartDate() {
            if (!this.selectedTaskStartDate) return '';
            const date = new Date(this.selectedTaskStartDate);
            const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' };
            return date.toLocaleDateString('ko-KR', options).replace(/\s/g, '');
        },
        formattedTaskEndDate() {
            if (!this.selectedTaskEndDate) return '';
            const date = new Date(this.selectedTaskEndDate);
            const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' };
            return date.toLocaleDateString('ko-KR', options).replace(/\s/g, '');
        },
        canCheckAllDay() {            
            return !!this.selectedScheduleStartDate && !!this.selectedScheduleEndDate; 
        },
        sortedComments() {
          if (!this.taskDetailInfo.comments) return [];
          return [...this.taskDetailInfo.comments].sort(
            (a, b) => new Date(b.createdDtm) - new Date(a.createdDtm)
          );
        },
        visibleComments() {
          return this.sortedComments.slice(0, this.initCommentViewCount);
        },
    },
  watch: {
    searchManagerName(newVal) {
        if (newVal.trim() === "") {
            this.searchManagerUserList = [];
            return;
        }
        this.searchManager(newVal);     
    },
    searchParticipantName(newVal) {
        if (newVal.trim() === "") {
            this.searchParticipantUserList = [];
            return;
        }
        this.searchParticipant(newVal);     
    },
    isAllDay(val) {
        if (!this.scheduleStartDateTime || !this.scheduleEndDateTime) return;

        if (val === 'Y') {
            const startDate = this.scheduleStartDateTime.slice(0, 10);
            const endDate = this.scheduleEndDateTime.slice(0, 10);
            this.selectedScheduleStartDate = this.scheduleStartDateTime = startDate + 'T00:00';
            this.selectedScheduleEndDate = this.scheduleEndDateTime = endDate + 'T23:59';
        }
    }
  },
  methods: {
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
    },
    toggleTaskCategoryFilter() {
      this.isTaskCatgoryOpen = !this.isTaskCatgoryOpen;
    },
    toggleStatusCategoryFilter() {
      this.isStatusCatgoryOpen = !this.isStatusCatgoryOpen;
    },
    togglePriorityCategoryFilter() {
      this.isPriorityCatgoryOpen = !this.isPriorityCatgoryOpen;
    },
    toggleStartDateCategoryFilter() {
      this.isStartDateCatgoryOpen = !this.isStartDateCatgoryOpen;
    },
    toggleEndDateCategoryFilter() {
      this.isEndDateCatgoryOpen = !this.isEndDateCatgoryOpen;
    },
    toggleSettingFilter() {
      this.isSettingPopupOpen = !this.isSettingPopupOpen;
    },
    toggleTaskAddDropdownFilter() {
      this.isTaskAddDropdownOpen = !this.isTaskAddDropdownOpen;
    },
    toggleGroup(index) {
      this.subMenuGroups[index].open = !this.subMenuGroups[index].open;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    handleClickOutside(event) {
      const box = this.$refs.addListBox;
      if (this.isTaskAddDropdownOpen && box && !box.contains(event.target)) {
        this.isTaskAddDropdownOpen = false;
      }
    },
    formatDateToYYYYMMDD(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatDateYYYYMMDD(date) {
      if (!date) return null;
      const onlyDate = date.split(" ")[0];
      return onlyDate;
    },
    formatDate(value) {
        if (!value) return '';
        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} ${hour}:${minute}`;
    },    
    getWeekofDay(dateStr) {
        const date = new Date(dateStr);
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        return days[date.getDay()];
    },
    selectItem(option) {
      this.selectedOption = option;
      this.isDropdownOpen = false;
      if (option === "전체공개") {
        this.selectedViewType = "P";
      } else if (option === "프로젝트 관리자만") {
        this.selectedViewType = "A";
      } 
    },
    handleTaskStartDateChange(date) {
        if (this.selectedTaskEndDate && date > this.selectedTaskEndDate) {
            this.toast.error(this.alertMsg['taskStartDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
            this.selectedTaskStartDate = null;
        } else {
            this.selectedTaskStartDate = date;
        }
        this.isTaskStartDatePickerOpen = false;
    },
    handleTaskEndDateChange(date) {
        if (this.selectedTaskStartDate && date < this.selectedTaskStartDate) {
            this.toast.error(this.alertMsg['taskEndDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
            this.selectedTaskEndDate = null;
        } else {
            this.selectedTaskEndDate = date;
        }
        this.isTaskEndDatePickerOpen = false;
    },    
    handleScheduleStartDateChange() {
        if (!this.scheduleStartDateTime) return;

        const start = new Date(this.scheduleStartDateTime);
        const end = this.scheduleEndDateTime ? new Date(this.scheduleEndDateTime) : null;
        const now = new Date();
        
        if (start < now) {
            this.toast.error(this.alertMsg['scheduleStartDateValidNow'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleStartDateTime.value = '';
            this.scheduleStartDateTime = '';
            return;
        }

        if (end && start > end) {
            this.toast.error(this.alertMsg['scheduleStartDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleStartDateTime.value = '';
            this.scheduleStartDateTime = '';
            return;
        }

        this.selectedScheduleStartDate = this.$refs.scheduleStartDateTime.value;
    },
    handleScheduleEndDateChange() {
        if (!this.scheduleEndDateTime) return;

        const end = new Date(this.scheduleEndDateTime);
        const now = new Date();

        if (end < now) {
            this.toast.error(this.alertMsg['scheduleEndDateValidNow'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleEndDateTime.value = '';
            this.scheduleEndDateTime = '';            
            return;
        }

        if (!this.scheduleStartDateTime) return;

        const start = new Date(this.scheduleStartDateTime);

        if (end < start) {
            this.toast.error(this.alertMsg['scheduleEndDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleEndDateTime.value = '';
            this.scheduleEndDateTime = '';
            return;
        }

        this.selectedScheduleEndDate = this.$refs.scheduleEndDateTime.value;
    },
    navigateProjectMenu(menu) {
        const nameMap = {
            //feed: 'ReportFeed',
            feed: 'ReportList',
            task: 'ReportTask',
            calendar: 'ReportCalendar'
        };

        if (nameMap[menu]) {
            this.$router.push({ name: nameMap[menu], params: { projectId: this.projectId } });
        } else {
            console.warn(`Unknown menu: ${menu}`);
        }
    },
    async getProjectInfo() {
      try {
        const response = await apiClient.post("/api/Project/project-info", {
          ProjectId: this.projectId,
        });

        if (response.status === 200) {
          const data = response.data;
          this.projectInfo = data.project || {};
          this.projectName = data.project.Name;
        }
      } catch (error) {
        console.error("Error fetching projectInfo data:", error);
      }
    },
    async getUserTaskViewSetting() {
      try {
        const response = await apiClient.post("/api/Task/user-task-view-setting", {
          ProjectId: this.projectId,
          LoginUserId: localStorage.getItem("userid")
        });

        if (response.status === 200) {
          const result = JSON.parse(response.data);
          const rows = result.data;

          if (Array.isArray(rows) && rows.length > 0) {
            const settings = rows[0].taskViewSettingList;
            const userOrderKeys = settings.map(s => s.settingKey);

            const merged = userOrderKeys.map(key => {
              const def = this.defaultTaskListOrder.find(d => d.settingKey === key);
              const found = settings.find(s => s.settingKey === key);
              return {
                ...def,
                viewYN: found ? found.viewYN : def.viewYN
              };
            });

            this.defaultTaskListOrder.forEach(def => {
              if (!userOrderKeys.includes(def.settingKey)) {
                merged.push(def);
              }
            });

            this.taskListOrder = merged;
          } else {
            this.taskListOrder = this.defaultTaskListOrder;
          }
        }
      } catch (error) {
        console.error("Error fetching userTaskViewSetting data:", error);
        this.taskListOrder = this.defaultTaskListOrder;
      }
    },
    async addPost() {
      if (!this.postSubject || this.postSubject.trim() === "") {
        this.toast.error(this.alertMsg['postSubject'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        this.$refs.postSubject.focus();
        return; 
      }
      if (!this.postContent || this.postContent.trim() === "") {
        this.toast.error(this.alertMsg['postContent'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        this.$refs.postContent.focus();
        return; 
      }

      try {
          const response = await apiClient.post(`/api/Post/post-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            Subject: this.postSubject,
            Content: this.postContent,
            ViewType: this.selectedViewType
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successPostAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddPostPopup = false;
            this.initPostPopupVaule();
          }
      } catch (error) {
        console.error("Error adding post data:", error);
        this.toast.error(this.alertMsg['failPostAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async addTask() {
      if (!this.taskSubject || this.taskSubject.trim() === "") {
        this.toast.error(this.alertMsg['taskSubject'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.taskSubject.focus();
        return; 
      }
      if (!this.selectedTaskStatus) {
        this.toast.error(this.alertMsg['taskStatus'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedTaskManager) {
        this.toast.error(this.alertMsg['taskManager'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedTaskStartDate) {
        this.toast.error(this.alertMsg['taskStartDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedTaskEndDate) {
        this.toast.error(this.alertMsg['taskEndDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.taskContent || this.taskContent.trim() === "") {
        this.toast.error(this.alertMsg['taskContent'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.taskContent.focus();        
        return; 
      }

      try {
          const subTaskListData = Array.isArray(this.subTaskList)
            ? this.subTaskList
            .filter(subtask => subtask.name && subtask.name.trim() !== '')
            .map(subtask => ({
                SubTaskSubject: subtask.name,
                SubTaskStatus: subtask.status,
                SubTaskEndDate: this.formatDateToYYYYMMDD(subtask.subTaskEndDate),
                SubTaskPriority: subtask.selectedSubTaskPriority?.value || null,
                SubTaskManagerUserId: subtask.selectedSubTaskManager?.managerUserId || null
                }))
            : [];
            
          const response = await apiClient.post(`/api/Task/task-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            Subject: this.taskSubject,
            ManagerUserId: this.selectedTaskManager.managerUserId,
            Status: this.selectedTaskStatus,
            TaskStartDate : this.formatDateToYYYYMMDD(this.selectedTaskStartDate),
            TaskEndDate : this.formatDateToYYYYMMDD(this.selectedTaskEndDate),
            Priority: this.selectedPriority?.value || null,       
            ProgressNum: this.taskProgress,            
            Content: this.taskContent,
            ViewType: this.selectedViewType,
            SubTaskList: subTaskListData
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successTaskAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddTaskPopup = false;
            this.initTaskPopupVaule();
          }
      } catch (error) {
        console.error("Error adding task data:", error);
        this.toast.error(this.alertMsg['failTaskAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async addSchedule() {
      if (!this.scheduleSubject || this.scheduleSubject.trim() === "") {
        this.toast.error(this.alertMsg['scheduleSubject'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.scheduleSubject.focus();
        return; 
      }
      if (!this.selectedScheduleStartDate) {
        this.toast.error(this.alertMsg['scheduleStartDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedScheduleEndDate) {
        this.toast.error(this.alertMsg['scheduleEndDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedParticipantUserList.length) {
        this.toast.error(this.alertMsg['scheduleParticipant'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }  
      if (!this.scheduleContent || this.scheduleContent.trim() === "") {
        this.toast.error(this.alertMsg['scheduleContent'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.scheduleContent.focus();        
        return; 
      }

      try {
          const participantListData = Array.isArray(this.selectedParticipantUserList)
            ? this.selectedParticipantUserList.map(participantUser => ({
                    ScheduleParticipantUserId: participantUser.managerUserId
                }))
            : [];
            
          const response = await apiClient.post(`/api/Schedule/schedule-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            Subject: this.scheduleSubject,
            StartDtm : this.selectedScheduleStartDate,
            EndDtm : this.selectedScheduleEndDate,
            AlldayYn: this.isAllDay,
            Location: this.scheduleLocation ? this.scheduleLocation : '',
            BeforeAlarm: this.beforeAlarm,
            Content: this.scheduleContent,
            ParticipantList: participantListData
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successScheduleAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddSchedulePopup = false;
            this.initSchedulePopupVaule();
          }
      } catch (error) {
        console.error("Error adding task data:", error);
        this.toast.error(this.alertMsg['failScheduleAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async searchManager(keyword) {
      try {
        const response = await apiClient.post("/api/Task/manager-search", {
          ManagerUserName: keyword 
        });
        
        if (response.status === 200) {
            const data = JSON.parse(response.data);
            this.searchManagerUserList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching managerUserList data:", error);
      }
    },
    async searchParticipant(keyword) {
      try {
        const response = await apiClient.post("/api/Task/manager-search", {
          ManagerUserName: keyword 
        });
        
        if (response.status === 200) {
            const data = JSON.parse(response.data);
            this.searchParticipantUserList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching participantUserList data:", error);
      }
    },
    selectTaskManager(person) {
        this.selectedTaskManager = person;
        this.isManagerPopupOpen = false;
        this.searchManagerName = '';
    },
    selectPriority(priority) {
        this.selectedPriority = priority;
        this.isPriorityPopupOpen = false;
    },    
    selectScheduleParticipant(person) {
        const isExist = this.selectedParticipantUserList.some(
            user => user.managerUserId === person.managerUserId
        );

        if (!isExist) {
            this.selectedParticipantUserList.push(person);
        }
        
        this.isParticipantPopupOpen = false;
        this.searchParticipantName = '';
    },
    removeParticipant(index) {
        this.selectedParticipantUserList.splice(index, 1);
    },
    handleManagerInput(event) {
        this.searchManagerName = event.target.value;
    },
    handleParticipantInput(event) {
        this.searchParticipantName = event.target.value;
    },
    checkAllDayClick(e) {
        if (!this.canCheckAllDay) {
            e.preventDefault();
            this.toast.error(this.alertMsg['checkAllday'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
        }
    },
    initPostPopupVaule() {
      this.postSubject = this.postContent = '';
      this.selectedViewType = 'P';
    },
    initTaskPopupVaule() {
      this.taskSubject = '';
      this.selectedTaskStatus = '';
      this.selectedTaskManager = '';
      this.selectedTaskStartDate = '';
      this.selectedTaskEndDate = '';
      this.selectedPriority = '';
      this.isPriorityProgressOpen = false;
      this.taskProgress = 0;
      this.taskContent = '';
      this.selectedViewType = "P";
      this.subTaskList = [];
    },
    initSchedulePopupVaule() {
      this.scheduleSubject = '';
      this.selectedParticipantUserList = [];
      this.scheduleStartDateTime = '';
      this.scheduleEndDateTime = '';
      this.selectedScheduleStartDate = '';
      this.selectedScheduleEndDate = '';
      this.scheduleLocation = '';
      this.scheduleContent = '';
      this.isAllDay = 'N';
      this.beforeAlarm = 0;
      this.selectedViewType = "P";
    },
    initAllPopup(type) {
      ['showAddPostPopup', 'showAddTaskPopup', 'showAddSchedulePopup'].forEach(key => {
        this[key] = false;
      });

      const map = {
        post: 'showAddPostPopup',
        task: 'showAddTaskPopup',
        schedule: 'showAddSchedulePopup',
      };

      if (map[type]) {
        this[map[type]] = true;
      }

      this.initPostPopupVaule();
      this.initTaskPopupVaule();
      this.initSchedulePopupVaule();
    },
    updateTaskProgress(event) {
        this.taskProgress = Number(event.target.value);
    },
    addSubTask() {
        const newSubTask = {
            id: Date.now(),
            status: 'R',
            name: '',
            isDatePickerOpen: false,
            subTaskEndDate: null,
            isSubTaskPriorityPopupOpen: false,
            selectedSubTaskPriority: null,
            isSubTaskManagerPopupOpen: false,
            selectedSubTaskManager: null,
        };
        
        this.subTaskList.push(newSubTask);

        this.$nextTick(() => {
            let el = this.$refs['subtask_' + newSubTask.id];

            if (Array.isArray(el)) el = el[0];
            if (el) el.focus();
        });
    },    
    handleEnter() {
        this.addSubTask();

        this.$nextTick(() => {
            const last = this.subTaskList[this.subTaskList.length - 1];
            const refName = 'subtask_' + last.id;

            let input = this.$refs[refName];

            if (Array.isArray(input)) input = input[0];

            if (input) {
                if (typeof input.focus === 'function') {
                    input.focus();
                } else if (input.$el && typeof input.$el.focus === 'function') {
                    input.$el.focus();
                }
            }
        });
    },
    toggleDatePicker(clickedSubTask) {        
        if (clickedSubTask.isDatePickerOpen) {
            clickedSubTask.isDatePickerOpen = false;
            return;
        }

        this.subTaskList.forEach(subTask => {
            subTask.isDatePickerOpen = false;
            subTask.isSubTaskPriorityPopupOpen = false;
            subTask.isSubTaskManagerPopupOpen = false;
        });

        this.$nextTick(() => {
            clickedSubTask.isDatePickerOpen = true;
        });
    },
    togglePriorityPopup(clickedSubTask) {    
        this.subTaskList.forEach(subTask => {
            subTask.isDatePickerOpen = false;
            subTask.isSubTaskManagerPopupOpen = false;

            if (subTask !== clickedSubTask) {
                subTask.isSubTaskPriorityPopupOpen = false;
            }
        });

        clickedSubTask.isSubTaskPriorityPopupOpen = !clickedSubTask.isSubTaskPriorityPopupOpen;
    },
    toggleManagerPopup(clickedSubTask) {
        this.searchManagerName = '';
        this.subTaskList.forEach(subTask => {
            subTask.isDatePickerOpen = false;
            subTask.isSubTaskPriorityPopupOpen = false;

            if (subTask !== clickedSubTask) {
                subTask.isSubTaskManagerPopupOpen = false;
            }
        });

        clickedSubTask.isSubTaskManagerPopupOpen = !clickedSubTask.isSubTaskManagerPopupOpen;
    },
    selectSubTaskPriority(subTask, priority) {
        subTask.selectedSubTaskPriority = priority;
        subTask.isSubTaskPriorityPopupOpen = false;
    },
    selectSubTaskManager(subTask, person) {
        subTask.selectedSubTaskManager = person;
        subTask.isSubTaskManagerPopupOpen = false;
    },    
    initTaskListViewSetting() {
        this.taskListOrder.forEach(item => item.viewYN = "Y");
        this.taskListOrder = [
          { settingKey: "subject", settingLabel: "업무명", viewYN: "Y" },
          { settingKey: "status", settingLabel: "상태", viewYN: "Y" },
          { settingKey: "priority", settingLabel: "우선순위", viewYN: "Y" },
          { settingKey: "manager", settingLabel: "담당자", viewYN: "Y" },
          { settingKey: "start_date", settingLabel: "시작일", viewYN: "Y" },
          { settingKey: "end_date", settingLabel: "마감일", viewYN: "Y" },
          { settingKey: "task_no", settingLabel: "업무번호", viewYN: "Y" },
          { settingKey: "created_user", settingLabel: "작성자", viewYN: "Y" },
          { settingKey: "created_dtm", settingLabel: "등록일", viewYN: "Y" },
          { settingKey: "updated_dtm", settingLabel: "수정일", viewYN: "Y" },
          { settingKey: "progress_num", settingLabel: "진척도", viewYN: "Y" }
        ];
    },
    initSortable() {
        this.$nextTick(() => {
          const el = this.$refs.sortableList;
          if (!el) return;
          Sortable.create(el, {
            animation: 150,
            onEnd: (evt) => {
              const moved = this.taskListOrder.splice(evt.oldIndex, 1)[0];
              this.taskListOrder.splice(evt.newIndex, 0, moved);
            }
          });
        });
    },
    async addTaskListViewSetting() {
        const settingsJson = this.taskListOrder.map((item, index) => ({
          SettingKey: item.settingKey,
          SettingLabel: item.settingLabel,
          ViewYN: item.viewYN,
          OrderNum: index + 1
        }));
        
        try {
          const response = await apiClient.post(`/api/Task/task-view-setting-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            TaskViewSettingList: settingsJson
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successTaskViewSettingAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.isSettingPopupOpen = false;
          }
      } catch (error) {
        console.error("Error adding task list view setting data:", error);
        this.toast.error(this.alertMsg['failTaskViewSettingAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async getAllTaskList() {        
      try {
          const response = await apiClient.post("/api/Task/task-list", {
            ProjectId: this.projectId
          });

          if (response.status === 200) {
            const result = JSON.parse(response.data);
            this.taskList = result.data;
            this.taskList = result.data.map(t => ({ ...t, subTaskList: Array.isArray(t.subTaskList) ? t.subTaskList : []  })); 
          }
      } catch (error) {
        console.error("Error fetching task list data:", error);
        this.taskListOrder = this.defaultTaskListOrder;
      }
    },
    async getTaskDetail(taskId) {
      try {
          const response = await apiClient.post("/api/Task/task-detail", {
            ProjectId: this.projectId,
            TaskId: taskId,
            LoginUserId: localStorage.getItem("userid")
          });

          if (response.status === 200) {
            const result = JSON.parse(response.data);
            this.taskDetailInfo = result.data[0];
            this.taskDetailInfo.subTaskList = Array.isArray(this.taskDetailInfo.subTaskList) ? this.taskDetailInfo.subTaskList : [];
          }
      } catch (error) {
        console.error("Error fetching task detail info data:", error);
        this.taskListOrder = this.defaultTaskListOrder;
      }
    },
    async addComment(feedId, feedType, parentCommentId = 0) {
        if (!this.newComment || this.newComment.trim() === "") {
            this.toast.error(this.alertMsg['commentContent'], { 
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
            this.$refs.newComment.focus();
            return; 
        }

        try {
            const response = await apiClient.post(`/api/Feed/feed-comment-add`, {
                FeedId: feedId,
                ParentCommentId: parentCommentId,
                FeedType: feedType,
                CommentContent: this.newComment,
                CreatedUserId: localStorage.getItem("userid"),
            });

            if (response.status === 200) {
                const savedComment = response.data.comment;                     

                const newComment = {
                    id: savedComment.CommentId,
                    feedId: savedComment.FeedId,
                    parentCommentId: Number(savedComment.ParentCommentId),
                    commentContent: savedComment.CommentContent,
                    createdDtm: savedComment.CreatedDtm,
                    createdUserId: savedComment.CreatedUserId,
                    createdUserName: savedComment.CreatedUserName,
                    createdUserPhoto: savedComment.CreatedUserPhoto,
                    children: []
                };

                if (!this.taskDetailInfo.comments) this.taskDetailInfo.comments = [];

                if (newComment.parentCommentId) {
                  const parent = this.taskDetailInfo.comments.find(c => c.id === newComment.parentCommentId);
                  parent ? parent.children.push(newComment) : this.taskDetailInfo.comments.push(newComment);
                } else {
                  this.taskDetailInfo.comments.unshift(newComment);
                }

                this.taskDetailInfo.comments.sort((a, b) => new Date(b.createdDtm) - new Date(a.createdDtm));
                this.taskDetailInfo.commentCount = (this.taskDetailInfo.commentCount || 0) + 1;
                this.newComment = "";
            }
        } catch (error) {
            console.error("Error adding comment data:", error);
            this.toast.error(this.alertMsg['failCommentAdd'], { 
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
        }
    },
    showTaskDetail(taskId) {
      this.showTaskDetailPopup = true;
      this.getTaskDetail(taskId);
    },    
    showMoreComments() {
      this.initCommentViewCount = Math.min(
        this.initCommentViewCount + this.moreCommentViewCount,
        this.taskDetailInfo.commentCount
      );
    },
    async likeFeed(task) {
        try {            
          const likeActiveYN = task.likeActiveYN === 'Y' ? 'N' : 'Y';

          const response = await apiClient.post(`/api/Feed/feed-like`, {
            FeedId: task.taskId,
            FeedType: 'T',
            LikeActiveYN: likeActiveYN,
            CreatedUserId: localStorage.getItem("userid"),
          });

          if (response.status === 200) {
            task.likeActiveYN = likeActiveYN;

            if (likeActiveYN === 'Y') {
                this.toast.success(this.alertMsg['successLikeFeed'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            } else {
                this.toast.success(this.alertMsg['successUnLikeFeed'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            }
          }
      } catch (error) {
            console.error("Error like feed data:", error);
            this.toast.error(this.alertMsg['failLikeFeed'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
      }
    },
    async likeBookmark(task) {
        try {
          const bookmarkActiveYN = task.bookmarkActiveYN === 'Y' ? 'N' : 'Y';

          const response = await apiClient.post(`/api/Feed/feed-bookmark`, {
            FeedId: task.taskId,
            FeedType: 'T',
            BookmarkActiveYN: bookmarkActiveYN,
            CreatedUserId: localStorage.getItem("userid"),
          });

          if (response.status === 200) {
            task.bookmarkActiveYN = bookmarkActiveYN;
            
            if (bookmarkActiveYN === 'Y') {
                this.toast.success(this.alertMsg['successBookmarkFeed'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            } else {
                this.toast.success(this.alertMsg['successUnBookmarkFeed'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            }
          }
      } catch (error) {
            console.error("Error bookmark feed data:", error);
            this.toast.error(this.alertMsg['failBookmarkFeed'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
      }
    },
    async likeFeedComment(comment) {
        try {            
          const likeActiveYN = comment.commentLikeActiveYn === 'Y' ? 'N' : 'Y';
          
          const response = await apiClient.post(`/api/Feed/feed-comment-like`, {
            FeedId: comment.feedId,
            CommentId: comment.commentId,
            FeedType: 'T',
            LikeActiveYN: likeActiveYN,
            CreatedUserId: localStorage.getItem("userid"),
          });

          if (response.status === 200) {
            comment.commentLikeActiveYn = likeActiveYN;

            if (likeActiveYN === 'Y') {
                this.toast.success(this.alertMsg['successLikeFeedComment'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            } else {
                this.toast.success(this.alertMsg['successUnLikeFeedComment'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            }
          }
      } catch (error) {
            console.error("Error like feed data:", error);
            this.toast.error(this.alertMsg['failLikeFeedComment'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
      }
    },
    showAlert() {
        this.toast.error(this.alertMsg['commingSoon'], {
            position: "top-center", // 메시지 위치
            timeout: 1500, // 3초 동안 표시
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true, // 진행 표시줄 숨기기
            closeButton: false, // X 버튼 숨기기
        });
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.getProjectInfo();
    this.initSortable();
    this.getUserTaskViewSetting();
    this.getAllTaskList();
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

